import axios from 'axios'

export default {
    /**
     * 查询包机组列表
     */
    async searchBaojiList(data, callback) {
        // 请求后台查询内容
         var res = await axios({
             method: 'post',
             url: 'User_battgroup_baojigroupAction!searchAll',
             data: data,
         });

         res = JSON.parse(res.data.result);
         // 执行回调返回查询内容
         callback(res);
    },

    /**
     * 添加包机组
     */
    async addBaojiList(data, callback) {
        // 请求后台查询内容
        var res = await axios({
            method: 'post',
            url: 'User_battgroup_baojigroupAction!add',
            data: data,
        });

        res = JSON.parse(res.data.result);
        // 执行回调返回查询内容
        callback(res);
    },

    /**
     * 编辑包机组
     */
    async editBaojiList(data, callback) {
        // 请求后台查询内容
        var res = await axios({
            method: 'post',
            url: 'User_battgroup_baojigroupAction!update',
            data: data,
        });

        res = JSON.parse(res.data.result);
        // 执行回调返回查询内容
        callback(res);
    },

    /**
     * 删除包机组
     */
    async delBaojiList(data, callback) {
        // 请求后台查询内容
        var res = await axios({
            method: 'post',
            url: 'User_battgroup_baojigroupAction!delete',
            data: data,
        });

        res = JSON.parse(res.data.result);
        // 执行回调返回查询内容
        callback(res);
    },

    /**
     * 查询包机组的用户
     */
    async searchBaojiUser(data, callback) {
        // 请求后台查询内容
         var res = await axios({
             method: 'post',
             url: 'User_battgroup_baojigroupAction!serchByCondition',
             data: data,
         });

         res = JSON.parse(res.data.result);
         // 执行回调返回查询内容
         callback(res);
    },

    /**
     * 添加包机组的用户
     */
    async addBaojiUser(data, callback) {
        // 请求后台查询内容
         var res = await axios({
             method: 'post',
             url: 'User_battgroup_baojigroup_usrAction!add',
             data: data,
         });

         res = JSON.parse(res.data.result);
         // 执行回调返回查询内容
         callback(res);
    },

    /**
     * 移除包机组的用户
     */
    async delBaojiUser(data, callback) {
        // 请求后台查询内容
         var res = await axios({
             method: 'post',
             url: 'User_battgroup_baojigroup_usrAction!delPro',
             data: data,
         });

         res = JSON.parse(res.data.result);
         // 执行回调返回查询内容
         callback(res);
    },

    /**
     * 查询包机组的机房
     */
    async searchBaojiHome(data, callback) {
        // 请求后台查询内容
        var res = await axios({
            method: 'post',
            url: 'User_battgroup_baojigroupAction!serchByInfo',
            data: data,
        });

        res = JSON.parse(res.data.result);
        // 执行回调返回查询内容
        callback(res);
    },

    /**
     * 添加包机组的机房
     */
    async addBaojiHome(data, callback) {
        // 请求后台查询内容
         var res = await axios({
             method: 'post',
             url: 'User_battgroup_baojigroup_battgroupAction!addPro_CS',
             data: data,
         });

         res = JSON.parse(res.data.result);
         // 执行回调返回查询内容
         callback(res);
    },

    /**
     * 添加包机组的机房
     */
    async delBaojiHome(data, callback) {
        // 请求后台查询内容
         var res = await axios({
             method: 'post',
             url: 'User_battgroup_baojigroup_battgroupAction!delPro_CS',
             data: data,
         });

         res = JSON.parse(res.data.result);
         // 执行回调返回查询内容
         callback(res);
    },
}